// Един ред от менюто на „Складова база": икона, етикет и значка с брояч.
// Свит sidebar (рейл на таблет) → само иконата с tooltip, а значката става
// точка в ъгъла ѝ. Цветът на значката и точката е по тона на сигнала
// (`navBadgeToneOf`): червено — критично, меко кехлибарено — внимание, сиво —
// брояч; без тон — вниманието.
import { Tooltip } from "antd";
import type { InventoryNavItem } from "../shell/inventoryNav";
import { SIGNAL_BADGE_CLASS, SIGNAL_DOT_CLASS, type SignalTone } from "../list/signals";

type Props = {
  item: InventoryNavItem;
  label: string;
  active: boolean;
  collapsed: boolean;
  badge?: number;
  badgeTone?: SignalTone | null;
  onClick: () => void;
};

export const SidebarNavItem = ({
  item,
  label,
  active,
  collapsed,
  badge,
  badgeTone,
  onClick,
}: Props) => {
  const { Icon } = item;
  const hasBadge = !!badge && badge > 0;
  const tone: SignalTone = badgeTone ?? "attention";
  const button = (
    <button
      type="button"
      onClick={onClick}
      aria-current={active ? "page" : undefined}
      className={`relative mb-0.5 flex w-full cursor-pointer items-center gap-2.5 rounded-lg border-none text-left text-[13.5px] leading-[normal] outline-none transition-colors focus-visible:shadow-[0_0_0_3px_var(--color-brand-tint)] ${
        collapsed ? "justify-center py-[9px]" : "px-2.5 py-[9px]"
      } ${
        active
          ? "bg-surface font-semibold text-ink shadow-[0_1px_2px_rgba(28,26,23,0.08)]"
          : "bg-transparent font-medium text-body hover:bg-shade-1 hover:text-brand-deep-ink"
      }`}
    >
      <span className="relative inline-flex">
        <Icon className="text-[14px]" />
        {collapsed && hasBadge && (
          <span
            data-badge-tone={tone}
            className={`absolute -right-1.5 -top-1 h-2 w-2 rounded-full ${SIGNAL_DOT_CLASS[tone]}`}
          />
        )}
      </span>
      {!collapsed && (
        <span className="min-w-0 flex-1 truncate">{label}</span>
      )}
      {!collapsed && hasBadge && (
        <span
          data-badge-tone={tone}
          className={`flex h-5 min-w-5 items-center justify-center rounded-[10px] px-1.5 text-[11.5px] font-semibold leading-none ${SIGNAL_BADGE_CLASS[tone]}`}
        >
          {badge}
        </span>
      )}
    </button>
  );
  if (!collapsed) return button;
  return (
    <Tooltip
      title={hasBadge ? `${label} · ${badge}` : label}
      placement="right"
    >
      {button}
    </Tooltip>
  );
};

export default SidebarNavItem;
